import type { AxiosInstance } from 'axios';
import type { AxiosErrorMiddleware } from '@/services/middleware/AxiosMiddleware';
import type { AxiosRequestMiddleware } from './AxiosRequestMiddleware';

abstract class AbstractMiddleware {
    protected axiosInstance!: AxiosInstance;

    public setup(axiosInstance: AxiosInstance) {
        this.axiosInstance = axiosInstance;
    }

    public isRequestMiddleware(): this is AxiosRequestMiddleware {
        return (this as unknown as AxiosRequestMiddleware).onRequest !== undefined;
    }

    public isErrorMiddleware(): this is AxiosErrorMiddleware {
        return (this as unknown as AxiosErrorMiddleware).onError !== undefined;
    }
}

export default AbstractMiddleware;
